import React from "react";
import * as c from "./iconPlayAlt.module.scss";
import classNames from "classnames";

export const IconPlayAlt = ({ className, ...props }) => {
  return (
    <svg
      className={classNames(className, c.iconDefaultColors)}
      viewBox="0 0 66 48"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g className="layer">
        <rect height="48" id="svg_1" rx="8" width="66" />
        <path
          d="m27,34.7l0,-21.52c0,-0.85 1,-1.31 1.65,-0.76l12,10.35c0.46,0.39 0.47,1.08 0.03,1.49l-12,11.17c-0.64,0.6 -1.68,0.15 -1.68,-0.73z"
          id="svg_2"
        />
      </g>
    </svg>
  );
};
